exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.warning-message[data-v-16a6b2d9] {\n    font-weight: bold;\n    font-size: 1rem;\n}\n.heading[data-v-16a6b2d9] {\n    font-size: 1.125rem;\n}\n.font-small[data-v-16a6b2d9] {\n    font-size: .75rem;\n}\n.table-sm th[data-v-16a6b2d9], .table-sm td[data-v-16a6b2d9] {\n    padding: 0.15rem !important;\n}\n", ""]);

// exports
